<script setup>
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import {defineProps, ref, onBeforeMount, computed} from 'vue';
import TrainingDetail from '../../components/training/TrainingDetail.vue';
import TrainingParticipantsAdmin from '../../components/training/TrainingParticipantsAdmin.vue';
import {APIService} from '@/core/util/services/api.service';
import ParticipantsPresences from '../../components/participants/ParticipantsPresences.vue';

// Before
const props = defineProps({
  id: {type: Number, default: null},
  departments: {
    type: Array,
    default() {
      return [];
    },
  },
});
const roleId = ref(window.appGlobal.user.roleId);
const tabActive = ref('detail');
const training = ref(null);
const participant = ref({});
const userId = ref(window.appGlobal.user.id);

const http = new APIService(window.appGlobal.baseUrl, 'api/');

onBeforeMount(() => {
  http
    .request({
      method: 'GET',
      url: `api/training/${props.id}`,
    })
    .then(response => {
      training.value = response.data;

      participant.value = training.value.participantsDetails.find(
        item => item.id == window.appGlobal.user.id,
      );
    });
});

const isParticipant = computed(() => {
  return training.value?.participantsDetails
    .map(participant => participant.id)
    .includes(userId.value);
});

const isTrainer = computed(() => {
  return training.value?.trainer.map(t => t.id).includes(userId.value);
});
</script>
<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <nav
        role="navigation"
        aria-label="Topbar Menu"
        class="oxd-topbar-body-nav"
      >
        <ul>
          <li
            class="oxd-topbar-body-nav-tab"
            :class="{'--visited': tabActive === 'detail'}"
            @click="tabActive = 'detail'"
          >
            <a class="oxd-topbar-body-nav-tab-item">Detail</a>
          </li>
          <li
            v-if="isParticipant"
            class="oxd-topbar-body-nav-tab"
            :class="{'--visited': tabActive === 'presences'}"
            @click="tabActive = 'presences'"
          >
            <a class="oxd-topbar-body-nav-tab-item">
              Presences
            </a>
          </li>
          <li
            v-if="training?.owner_id === userId || roleId == 1 || isTrainer"
            class="oxd-topbar-body-nav-tab"
            :class="{'--visited': tabActive === 'participants'}"
            @click="tabActive = 'participants'"
          >
            <a class="oxd-topbar-body-nav-tab-item">
              Participants
            </a>
          </li>
        </ul>
      </nav>
      <br />
      <oxd-divider />
      <TrainingDetail
        v-if="tabActive === 'detail' && training != null"
        :training="training"
        :departments="departments"
      />
      <ParticipantsPresences
        v-if="tabActive == 'presences' && training != null && isParticipant"
        :id="training.id"
        :training="training"
        :participant="participant"
      />
      <TrainingParticipantsAdmin
        v-if="
          (training?.owner_id === userId || roleId === 1 || isTrainer) &&
            tabActive == 'participants' &&
            training != null
        "
        :training="training"
      />
    </div>
  </div>
</template>
<style scoped>
@media (min-width: 800px) {
  .oxd-topbar-body-nav-tab {
    position: relative;
  }
}
.oxd-topbar-body-nav ul:first-child {
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  padding: 0;
  margin: 0;
}
.oxd-topbar-body-nav-tab {
  height: 35px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  padding: 0 12px;
  margin-right: 15px;
  text-decoration: none;
  border-radius: 0.85rem;
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 600;
}
</style>
